import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DashboardLayout from './pages/DashboardLayout';
import CampaignPage from './pages/CreateAdCampaign';
import AudienceTargetingForm from './pages/AudienceTargetingForm';

import AuthRedirectHandler from './SystemHandler/AuthRedirectHandler';
import { BrokerProvider } from './contexts/BrokerContext';
import { InfoModalProvider } from './contexts/InfoModalContext';
import SpendCap from './pages/SpendCap';
import GetCampaign from './pages/GetCampaign';
import EditCampaign from './pages/EditCampaign';
import ViewAudience from './pages/ViewAudience';
import EditAudience from './pages/EditAudience';
import ViewSpendCaps from './pages/ViewSpendCaps';
import EditSpendCaps from './pages/EditSpendCaps';
import PublishCampaign from './pages/PublishCampaign';
import CampaignDashboard from './pages/CampaignDashboard';
import BillingHistory from './pages/BillingHistory';





function App() {
  return (
    <Router>
      <BrokerProvider>
        <InfoModalProvider>
          <AuthRedirectHandler>
            <DashboardLayout>

            <Routes>
              <Route path="/" element={<CampaignPage />} />
              <Route path="/create-campaign" element={<CampaignPage />} />
              <Route path="/create-audience" element={<AudienceTargetingForm />} />
              <Route path="/spend-caps" element={<SpendCap/>} />
              <Route path="/get-campaign" element={<GetCampaign />} />
              <Route path="/edit-campaign" element={<EditCampaign />} />
              <Route path="/viewAudience" element={<ViewAudience />} />
              <Route path="/edit-audience" element={<EditAudience />} />
              <Route path="/viewSpendCaps" element={<ViewSpendCaps />} />
              <Route path="/editSpendCaps" element={<EditSpendCaps />} />
              <Route path="/publish-campaign" element={<PublishCampaign />} />
              <Route path="/campaign-insights" element={<CampaignDashboard />} />
              <Route path="/billing-history" element={<BillingHistory />} />`

              

            </Routes>
          </DashboardLayout>
        </AuthRedirectHandler>
      </InfoModalProvider>
      </BrokerProvider>


    </Router>
  );
}

export default App;
